var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 54C0.625 53.1712 0.954241 52.3763 1.54029 51.7903C2.12634 51.2042 2.9212 50.875 3.75 50.875H66.25C67.0788 50.875 67.8737 51.2042 68.4597 51.7903C69.0458 52.3763 69.375 53.1712 69.375 54C69.375 54.8288 69.0458 55.6237 68.4597 56.2097C67.8737 56.7958 67.0788 57.125 66.25 57.125H3.75C2.9212 57.125 2.12634 56.7958 1.54029 56.2097C0.954241 55.6237 0.625 54.8288 0.625 54ZM0.625 29C0.625 28.1712 0.954241 27.3763 1.54029 26.7903C2.12634 26.2042 2.9212 25.875 3.75 25.875H66.25C67.0788 25.875 67.8737 26.2042 68.4597 26.7903C69.0458 27.3763 69.375 28.1712 69.375 29C69.375 29.8288 69.0458 30.6237 68.4597 31.2097C67.8737 31.7958 67.0788 32.125 66.25 32.125H3.75C2.9212 32.125 2.12634 31.7958 1.54029 31.2097C0.954241 30.6237 0.625 29.8288 0.625 29ZM0.625 4C0.625 3.1712 0.954241 2.37634 1.54029 1.79029C2.12634 1.20424 2.9212 0.875 3.75 0.875H66.25C67.0788 0.875 67.8737 1.20424 68.4597 1.79029C69.0458 2.37634 69.375 3.1712 69.375 4C69.375 4.8288 69.0458 5.62366 68.4597 6.20971C67.8737 6.79576 67.0788 7.125 66.25 7.125H3.75C2.9212 7.125 2.12634 6.79576 1.54029 6.20971C0.954241 5.62366 0.625 4.8288 0.625 4Z",
    fill: "#98A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.9026024e42d6dcd3cc55bb8367d89112.svg";
export { ForwardRef as ReactComponent };